var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g5, _g6, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionnaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.2 175C58.7776 175 25.2002 141.423 25.2002 100C25.2002 58.5774 58.7776 25 100.2 25C141.623 25 175.2 58.5774 175.2 100C175.2 141.423 141.623 175 100.2 175Z",
    fill: "url(#paint0_linear_26801_3952)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2002 46C39.2002 42.6863 41.8865 40 45.2002 40H169.2C172.514 40 175.2 42.6863 175.2 46V68.5155C175.2 71.8292 172.514 74.5155 169.2 74.5155H45.2002C41.8865 74.5155 39.2002 71.8292 39.2002 68.5155V46Z",
    fill: "url(#paint1_linear_26801_3952)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2002 71C46.9322 71 53.2002 64.732 53.2002 57C53.2002 49.268 46.9322 43 39.2002 43C31.4682 43 25.2002 49.268 25.2002 57C25.2002 64.732 31.4682 71 39.2002 71Z",
    fill: "url(#paint2_linear_26801_3952)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8923 52.5205C38.189 52.1845 38.6179 51.9764 39.0972 51.9764C39.9842 51.9764 40.7031 52.6954 40.7031 53.5823C40.7031 54.3298 40.1908 54.9617 39.4958 55.1387C38.5949 55.368 37.4914 56.1973 37.4914 57.597V58.3999C37.4914 59.2869 38.2103 60.0058 39.0972 60.0058C39.9842 60.0058 40.7031 59.2869 40.7031 58.3999V58.1253C42.5735 57.4639 43.9149 55.6815 43.9149 53.5823C43.9149 50.9216 41.758 48.7646 39.0972 48.7646C37.658 48.7646 36.3648 49.3977 35.4844 50.3952C34.8975 51.0601 34.9608 52.075 35.6258 52.6619C36.2906 53.2487 37.3056 53.1855 37.8923 52.5205ZM39.0975 61.6117C38.2106 61.6117 37.4916 62.3307 37.4916 63.2176C37.4916 64.1045 38.2106 64.8235 39.0975 64.8235H39.1136C40.0005 64.8235 40.7194 64.1045 40.7194 63.2176C40.7194 62.3307 40.0005 61.6117 39.1136 61.6117H39.0975Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_26801_3952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8572 49H67.9826C66.4434 49 65.2002 50.2432 65.2002 51.7824C65.2002 53.3216 66.4434 54.5648 67.9826 54.5648H89.8572C91.3964 54.5648 92.6396 53.3216 92.6396 51.7824C92.61 50.2432 91.3668 49 89.8572 49Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_26801_3952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.1687 51.7824C97.1687 53.3216 98.4119 54.5648 99.9511 54.5648H159.418C160.957 54.5648 162.2 53.3216 162.2 51.7824C162.2 50.2432 160.957 49 159.418 49H99.9215C98.3823 49 97.1687 50.2432 97.1687 51.7824Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_26801_3952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.9826 65.6945H120.257C121.796 65.6945 123.039 64.4513 123.039 62.9121C123.039 61.3728 121.796 60.1296 120.257 60.1296H67.9826C66.4434 60.1296 65.2002 61.3728 65.2002 62.9121C65.2002 64.4513 66.4434 65.6945 67.9826 65.6945Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_26801_3952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.173 65.6945H159.418C160.957 65.6945 162.2 64.4513 162.2 62.9121C162.2 61.3728 160.957 60.1296 159.418 60.1296H130.173C128.634 60.1296 127.39 61.3728 127.39 62.9121C127.39 64.4513 128.634 65.6945 130.173 65.6945Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2002 88.5155C39.2002 85.2018 41.8865 82.5155 45.2002 82.5155H169.2C172.514 82.5155 175.2 85.2018 175.2 88.5155V111.031C175.2 114.345 172.514 117.031 169.2 117.031H45.2002C41.8865 117.031 39.2002 114.345 39.2002 111.031V88.5155Z",
    fill: "url(#paint3_linear_26801_3952)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2002 100C67.2002 94.4772 71.6773 90 77.2002 90H97.2002C102.723 90 107.2 94.4772 107.2 100C107.2 105.523 102.723 110 97.2002 110H77.2002C71.6773 110 67.2002 105.523 67.2002 100ZM83.249 99.2174C82.8718 98.8414 82.2603 98.8414 81.8831 99.2174C81.506 99.5935 81.506 100.203 81.8831 100.579L85.4344 104.12C85.8116 104.496 86.4231 104.496 86.8003 104.12L93.3565 97.5833C93.7337 97.2072 93.7337 96.5975 93.3565 96.2215C92.9793 95.8455 92.3678 95.8455 91.9906 96.2215L86.1173 102.077L83.249 99.2174Z",
    fill: "#DAE7FD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.2 100C115.2 94.4772 119.677 90 125.2 90H145.2C150.723 90 155.2 94.4772 155.2 100C155.2 105.523 150.723 110 145.2 110H125.2C119.677 110 115.2 105.523 115.2 100ZM132.907 96.2929C132.517 95.9024 131.884 95.9024 131.493 96.2929C131.103 96.6834 131.103 97.3166 131.493 97.7071L134.286 100.5L131.493 103.293C131.103 103.683 131.103 104.317 131.493 104.707C131.884 105.098 132.517 105.098 132.907 104.707L135.7 101.914L138.493 104.707C138.884 105.098 139.517 105.098 139.907 104.707C140.298 104.317 140.298 103.683 139.907 103.293L137.114 100.5L139.907 97.7071C140.298 97.3166 140.298 96.6834 139.907 96.2929C139.517 95.9024 138.884 95.9024 138.493 96.2929L135.7 99.0858L132.907 96.2929Z",
    fill: "#DAE7FD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2002 113.516C46.9322 113.516 53.2002 107.247 53.2002 99.5155C53.2002 91.7835 46.9322 85.5155 39.2002 85.5155C31.4682 85.5155 25.2002 91.7835 25.2002 99.5155C25.2002 107.247 31.4682 113.516 39.2002 113.516Z",
    fill: "url(#paint4_linear_26801_3952)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8923 95.036C38.189 94.7 38.6179 94.4919 39.0972 94.4919C39.9842 94.4919 40.7031 95.2109 40.7031 96.0978C40.7031 96.8453 40.1908 97.4773 39.4958 97.6542C38.5949 97.8835 37.4914 98.7128 37.4914 100.113V100.915C37.4914 101.802 38.2103 102.521 39.0972 102.521C39.9842 102.521 40.7031 101.802 40.7031 100.915V100.641C42.5735 99.9794 43.9149 98.197 43.9149 96.0978C43.9149 93.4371 41.758 91.2802 39.0972 91.2802C37.658 91.2802 36.3648 91.9132 35.4844 92.9107C34.8975 93.5756 34.9608 94.5905 35.6258 95.1774C36.2906 95.7642 37.3056 95.701 37.8923 95.036ZM39.0975 104.127C38.2106 104.127 37.4916 104.846 37.4916 105.733C37.4916 106.62 38.2106 107.339 39.0975 107.339H39.1136C40.0005 107.339 40.7194 106.62 40.7194 105.733C40.7194 104.846 40.0005 104.127 39.1136 104.127H39.0975Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2002 131.031C39.2002 127.717 41.8865 125.031 45.2002 125.031H169.2C172.514 125.031 175.2 127.717 175.2 131.031V153.546C175.2 156.86 172.514 159.546 169.2 159.546H45.2002C41.8865 159.546 39.2002 156.86 39.2002 153.546V131.031Z",
    fill: "url(#paint5_linear_26801_3952)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8831 134.217C68.2603 133.841 68.8718 133.841 69.249 134.217L72.1173 137.077L77.9906 131.222C78.3678 130.845 78.9793 130.845 79.3565 131.222C79.7337 131.598 79.7337 132.207 79.3565 132.583L72.8003 139.12C72.4231 139.496 71.8116 139.496 71.4344 139.12L67.8831 135.579C67.506 135.203 67.506 134.593 67.8831 134.217Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_26801_3952)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.2002,
    y: 147,
    width: 40,
    height: 4,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_26801_3952)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.2002,
    y: 134,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2002 156.031C46.9322 156.031 53.2002 149.763 53.2002 142.031C53.2002 134.299 46.9322 128.031 39.2002 128.031C31.4682 128.031 25.2002 134.299 25.2002 142.031C25.2002 149.763 31.4682 156.031 39.2002 156.031Z",
    fill: "url(#paint6_linear_26801_3952)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8923 137.552C38.189 137.215 38.6179 137.007 39.0972 137.007C39.9842 137.007 40.7031 137.726 40.7031 138.613C40.7031 139.361 40.1908 139.993 39.4958 140.17C38.5949 140.399 37.4914 141.228 37.4914 142.628V143.431C37.4914 144.318 38.2103 145.037 39.0972 145.037C39.9842 145.037 40.7031 144.318 40.7031 143.431V143.156C42.5735 142.495 43.9149 140.713 43.9149 138.613C43.9149 135.953 41.758 133.796 39.0972 133.796C37.658 133.796 36.3648 134.429 35.4844 135.426C34.8975 136.091 34.9608 137.106 35.6258 137.693C36.2906 138.28 37.3056 138.216 37.8923 137.552ZM39.0975 146.643C38.2106 146.643 37.4916 147.362 37.4916 148.249C37.4916 149.136 38.2106 149.854 39.0975 149.854H39.1136C40.0005 149.854 40.7194 149.136 40.7194 148.249C40.7194 147.362 40.0005 146.643 39.1136 146.643H39.0975Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2002 146H70.2002L70.2002 152H76.2002V146ZM70.2002 144C69.0956 144 68.2002 144.895 68.2002 146V152C68.2002 153.105 69.0956 154 70.2002 154H76.2002C77.3048 154 78.2002 153.105 78.2002 152V146C78.2002 144.895 77.3048 144 76.2002 144H70.2002Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_26801_3952",
    x: 65.2002,
    y: 48,
    width: 27.4395,
    height: 6.56482,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_3952"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_3952"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_3952",
    result: "effect2_innerShadow_26801_3952"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_26801_3952",
    x: 97.1687,
    y: 48,
    width: 65.0317,
    height: 6.56482,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_3952"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_3952"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_3952",
    result: "effect2_innerShadow_26801_3952"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_26801_3952",
    x: 65.2002,
    y: 59.1296,
    width: 57.8389,
    height: 6.56482,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_3952"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_3952"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_3952",
    result: "effect2_innerShadow_26801_3952"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_26801_3952",
    x: 127.39,
    y: 59.1296,
    width: 34.8098,
    height: 6.56482,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_3952"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_3952"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_3952",
    result: "effect2_innerShadow_26801_3952"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_26801_3952",
    x: 87.2002,
    y: 146,
    width: 40,
    height: 5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_3952"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_3952"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_3952",
    result: "effect2_innerShadow_26801_3952"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_26801_3952",
    x: 87.2002,
    y: 133,
    width: 52,
    height: 5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_3952"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_3952"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_3952",
    result: "effect2_innerShadow_26801_3952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_3952",
    x1: 25.2002,
    y1: 36.7188,
    x2: 168.169,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_3952",
    x1: 107.2,
    y1: 40,
    x2: 107.2,
    y2: 74.5155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_3952",
    x1: 28.2627,
    y1: 43,
    x2: 60.642,
    y2: 63.1839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_3952",
    x1: 107.2,
    y1: 82.5155,
    x2: 107.2,
    y2: 117.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_3952",
    x1: 28.2627,
    y1: 85.5155,
    x2: 60.642,
    y2: 105.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_3952",
    x1: 107.2,
    y1: 125.031,
    x2: 107.2,
    y2: 159.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_3952",
    x1: 28.2627,
    y1: 128.031,
    x2: 60.642,
    y2: 148.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaire);
export default __webpack_public_path__ + "static/media/Questionnaire.f00fb86bc065938000ab9ce4b336e668.svg";
export { ForwardRef as ReactComponent };